import { ReactNode } from 'react';

export default function AuthLayout({ children }: { children: ReactNode }) {
  return (
    <div className="h-[100vh] w-[100vw] flex flex-col justify-center items-center grid-container bg-white">
      <div className="flex flex-col justify-center items-center h-full w-[90vw]">{children}</div>
    </div>
  );
}
